<template>
    <b-table
        id="indices"
        :items="resultado"
        :fields="fields"
        striped
        small
        responsive
        :busy="configTable.load"
        show-empty
        hover
        bordered
        class="mb-0"
        head-variant="light">
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Nenhum índice encontrado.</p>
        </template>
        <template v-slot:head(selecionar)="{ item }">
            <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
        </template>
        <template v-slot:cell(selecionar)="{ item }">
            <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(item.codRequisicaoParcela)" @change="toggleCheck($event, item)" />
        </template>
        <template v-slot:head(1)="{ item }">
            Número da Requisição <i class="filter" :class="!isEmpty(filtro.numeroRequisicao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Número da Requisição', 'mascara', '', '#########', $event)"></i>
        </template>
        <template v-slot:cell(1)="{ item }">
            {{ item.numeroRequisicao }}
        </template>
        <template v-slot:head(2)="{ item }">
            Linha Digitável <i class="filter" :class="!isEmpty(filtro.linhaDigitavel) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Linha Digitável', 'mascara', '', '###############################################', $event)"></i>
        </template>
        <template v-slot:cell(2)="{ item }">
            {{ item.linhaDigitavel }}
        </template>
        <template v-slot:head(3)="{ item }">
            Situação <i class="filter" :class="!isEmpty(filtro.situacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação', 'checkbox', listaSituacaoParcela, null, $event)"></i>
        </template>
        <template v-slot:cell(3)="{ item }">
            {{ item.situacao }}
        </template>
        <template v-slot:head(4)="{ item }">
            Data Emissão do Boleto <i class="filter" :class="!isEmpty(filtro.dataEmissao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Emissão do Boleto', 'data', '', null, $event)"></i>
        </template>
        <template v-slot:cell(4)="{ item }">
            <p class="text-center">
                {{ item.dataEmissao }}
            </p>
        </template>
    </b-table>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../mixins/formatarMixins';

export default {
    props: ['resultado', 'fields', 'configTable', 'selecteds', 'filtro'],
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
    },
    data() {
        return {
            urlApi: null,
            listaSituacaoParcela: null
        }
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    if(!this.selecteds.includes(el.codRequisicaoParcela)) {
                        this.selecteds.push(el.codRequisicaoParcela);
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    if(this.selecteds.includes(el.codRequisicaoParcela)) {
                        const index = this.selecteds.indexOf(el.codRequisicaoParcela);
                        this.selecteds.splice(index, 1);
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                this.selecteds.push(item.codRequisicaoParcela);
            } else {
                const index = this.selecteds.indexOf(item.codRequisicaoParcela);
                this.selecteds.splice(index, 1);
                this.configTable.checkedAll = false;
            }

        },
        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        },
        async listarSituacaoParcela() {
            axios.get(`${this.urlApi}/v1/boletoNaoEncontrado/listarSituacaoParcela`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.listaSituacaoParcela = response.data;
            })
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.listarSituacaoParcela();
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
